import { useEffect } from 'react';

/**
 * 2열 메뉴의 «지금 위치» 가 늘 화면 안에 서게 — 주소가 바뀌면 고른 줄을 보이는 자리로 (web 레인 W5).
 *
 * 평 2차 «2열 메뉴의 지금 여기가 화면 밖에 가려짐»(39 · 48 · 59 · 60 · 66) — 항목이 많은 메뉴에서
 * 고른 줄이 아래에 있으면 메뉴를 굴려야 보였다.
 * ★ `block: 'nearest'` — 이미 보이면 움직이지 않는다(메뉴가 들썩이지 않게).
 * ★ 선택자로 찾는다 — 셸의 마크업(ref)을 고치지 않으려는 것(소스 회귀 금지).
 */
export function useActiveIntoView(navSelector: string, pathname: string): void {
  useEffect(() => {
    const nav = document.querySelector(navSelector);
    const on = nav?.querySelector<HTMLElement>('[aria-current="page"]');
    if (on && typeof on.scrollIntoView === 'function') on.scrollIntoView({ block: 'nearest' });
  }, [navSelector, pathname]);
}
